import { clientHttp } from '@/common/http';
import {
  type GetExhibitionApi,
  getExhibitionInputSchema,
  getExhibitionResponseSchema,
} from './get-exhibition';

const EVENT_API_PATH = '/api/promotions';

export const getExhibition: GetExhibitionApi = async ({ input, signal }) => {
  const params = getExhibitionInputSchema.parse(input);
  const json = await clientHttp
    .get(`${EVENT_API_PATH}/${params.id}`, { signal })
    .json();
  return getExhibitionResponseSchema.parse(json);
};
